export const OutageTypeDetailDictionary: IOutageTypeDetailDictionary  = {
    "Breakdown": ["Reactive Breakdown",
        "Trip",
        "Comms/IT"],
    "Derate": ["Derate"],
    "DNO": ["DNO"],
    "Planned Maintenance": ["Scheduled Maintenance",
        "Scheduled Repair",
        "Condition-Based",
        "Statutory/Survey",
        "Electrical Defect",
        "PM Scheduled Electrical Maintenance"]
}

interface IOutageTypeDetailDictionary {
    [key: string]: string[]
}